import Image from "./Image";
import { UserInfo } from "@/sources/kicker-ovsyndication";
import { getSsoProfileFullName } from "@/helpers/profileHelpers";
import DefaultUser from "@/assets/user/default.svg";
import { SessionUser } from "./UserDisplay/UserModalDisplay";
// TODO:Timo TODO:Matthias use svg (right now its not working, IconDefaultUser.src is empty)

interface SessionUserImageType {
  user: SessionUser,
  className?: string,
  imageClassName?: string,
}

export function SessionUserImage({
  user,
  className,
  imageClassName,
  ...attributes
  }
  : SessionUserImageType) {
    return <UserImageImp image={user.image} name={user.name} className={className} imageClassName={imageClassName} {...attributes} />
}



interface UserImageType {
  user: UserInfo,
  className?: string,
  imageClassName?: string,
}

export default function UserImage(
  {
    user,
    className,
    imageClassName,
    ...attributes
  }: UserImageType) {
    return <UserImageImp image={user.profileImage} name={getSsoProfileFullName(user)} className={className} imageClassName={imageClassName} {...attributes} />
}



function UserImageImp(
  {
    image,
    name,
    className,
    imageClassName,
    ...attributes
  }
  :
  {image?:string, name?:string, className?:string, imageClassName?:string}) {

  return (
    <div className={`relative aspect-user ${className || ""}`}>
      {image
        ?
          <Image
            {...attributes}
            className={`rounded-full object-cover w-full aspect-user h-auto ${imageClassName}`}
            width="100"
            height="100"
            src={image}
            alt={`Profilbild: ${name}`}
          />
        :
          <DefaultUser 
            {...attributes} 
            className={`rounded-full object-cover w-full aspect-user h-auto ${imageClassName}`} 
            />
      }

    </div>
  )
}
